<template>
  <v-layout
    fluid
    assets-history
  >
    <v-skeleton-loader
      v-if="$apollo.loading"
      type="table-tbody"
      :tile="true"
      class="mx-auto"
      width="100%"
      max-height="265"
    />
    <v-layout
      v-if="!$apollo.loading && !_.isEmpty(portfolioAssetsHistory.accounts)" 
      wrap
    >
      <v-flex>
        <v-data-table  
          class="table text-no-wrap"
          :headers="headers"
          :items="portfolioAssetsHistory.accounts"
          :hide-default-footer="true"
          :fixed-header="true"
          :items-per-page="50"
          dense
        >
          <template v-slot:item.name="{ item }">
            <router-link
              :to="`connection/${item.period_id}?a=${item.account_id}`"
              class="mr-2"
            >
              <v-icon
                style="font-size:16px;"
              >
                mdi-eye
              </v-icon>
            </router-link>
            <router-link :to="`ranking/${item.ranking_id}`">
              <b class="text-primary">{{ item.project_ticker }}</b>
            </router-link>
            - 
            <small>{{ item.account_name }} {{ item.connection_id }}</small>
            <v-tooltip
              v-if="((item.avg_deposit / item.init_deposit ) - 1) * 100 >= item.allowed_drawdown_ptc"
              top
            >
              <template v-slot:activator="{ on }">
                <v-icon
                  class="text-positive"
                  style="margin: -1px 3px 0px; font-size:15px;"
                  v-on="on"
                >
                  mdi-shield-check
                </v-icon>
              </template>
              {{ $t('rankings.investorSave') }}
            </v-tooltip>
            <v-chip
              v-if="item.paused"
              class="ml-3 success text-black"
              x-small
              label
            >
              {{ $t('rankings.paused') }}
            </v-chip>
          </template> 
          <template v-slot:item.pnl_this_month_ptc="{ item }">
            <b :class="colorPnL(item.pnl_this_month_ptc)">
              {{ item.pnl_this_month_ptc }}%
            </b>
            <v-tooltip
              top
            >
              <template v-slot:activator="{ on }">
                <v-icon v-on="on">
                  mdi-information-outline
                </v-icon>
              </template>
              <span
                :class="colorPnL(item.pnl_this_month)" 
              >{{ item.base_currency | renderSymbol }} {{ item.pnl_this_month | formatMoney }}</span>
            </v-tooltip> 
          </template> 
          <template v-slot:item.pnl_total_ptc="{ item }">
            <b :class="colorPnL(item.pnl_total_ptc)">
              {{ item.pnl_total_ptc }}%
            </b>
            <v-tooltip
              top
            >
              <template v-slot:activator="{ on }">
                <v-icon v-on="on">
                  mdi-information-outline
                </v-icon>
              </template>
              <span
                :class="colorPnL(item.pnl_total_ptc)" 
              >{{ item.base_currency | renderSymbol }}  {{ item.pnl_total | formatMoney }}</span>
            </v-tooltip> 
          </template> 

          <template v-slot:item.current_upnl_ptc="{ item }">
            <b :class="colorPnL(item.current_upnl_ptc)">{{ item.current_upnl_ptc }}%</b>
          </template> 
          <template v-slot:item.trailing_stop_ptc="{ item }">
            <b class="text-neutral">{{ item.trailing_stop_ptc }}% </b>
            <v-tooltip
              top
            >
              <template v-slot:activator="{ on }">
                <v-icon v-on="on">
                  mdi-information-outline
                </v-icon>
              </template>
             
              <span
                class="text-black"
              >{{ $t('rankings.trailngStopExec') }}<br>
                {{ item.base_currency | renderSymbol }} {{ (item.avg_deposit - ( item.avg_deposit * item.allowed_drawdown_ptc / 100)) | formatMoney }}</span>
              <br>
              {{ $t('globals.allowedDrawdown') }}<br>
              {{ item.allowed_drawdown_ptc }}%
            </v-tooltip> 
          </template>
          <template v-slot:item.current_balance="{ item }">
            {{ item.base_currency | renderSymbol }} {{ item.current_balance | formatMoney }}
          </template> 

          <template v-slot:item.init_deposit="{ item }">
            {{ item.base_currency | renderSymbol }} {{ item.init_deposit | formatMoney }}
          </template> 
        </v-data-table>
      </v-flex>
    </v-layout> 
    <v-layout
      v-if="!$apollo.loading && _.isEmpty(portfolioAssetsHistory.accounts)" 
      wrap
    >
      <v-flex
        class="not-found"
        justify="center"
        align="center"
        py-10
      >
        <v-icon>mdi-ghost</v-icon>
        <p>{{ $t('dashboard.assetsHistoryNotFound') }}</p>
      </v-flex>
    </v-layout> 
  </v-layout>
</template>

<script>

const PORTFOLIO_ASSETS_HISTORY_QUERY = require('@/graphql/queries/PortfolioAssetsHistory.gql');


export default {
  name: 'PortfolioAssetsHistory',
  data() {
    return {
      loading: false,
      headers: [
        {
          sortable: false,
          text: this.$t('dashboard.name'),
          value: 'name'
        },
        {
          sortable: false,
          text: this.$t('globals.pnl_this_month'),
          value: 'pnl_this_month_ptc'
        },
        {
          sortable: false,
          text: this.$t('globals.pnl_total'),
          value: 'pnl_total_ptc'
        },
        {
          sortable: false,
          text: this.$t('rankings.upnl'),
          value: 'current_upnl_ptc'
        },
        {
          sortable: false,
          text: this.$t('rankings.trailingStop'),
          value: 'trailing_stop_ptc'
        },
        {
          sortable: false,
          text: this.$t('rankings.currentBalance'),
          value: 'current_balance'
        },
        {
          sortable: false,
          text: this.$t('rankings.initBalance'),
          value: 'init_deposit'
        }
        
      ]
    }
  },
  methods: {
   
  },
  apollo: {
    portfolioAssetsHistory: {
      query: PORTFOLIO_ASSETS_HISTORY_QUERY,
    }
  }
}
</script>

<style lang="scss">
.assets-history {
  .table {
    .v-icon {
      margin-top:-2.5px;
      font-size:13px;
    }
  }    
}

</style>
